import styled from 'styled-components';
import { Chip } from '../../../../../components/common/chip/Chip';
import { BulletListContainer, BulletListItem } from '../../../../../components/common/lists/BulletList';

export const Section1 = () => {
  return (
    <Container>
      <CollectInfoSection>
        <CollectInfoWrap>
          <CollectInfoTopSection>
            <CollectInfoTitleWrap>
              <CollectInfoTitle>{'트랙터 필수 정보'}</CollectInfoTitle>
              <Chip type="square" color="secondary" theme="light">
                {'필수'}
              </Chip>
            </CollectInfoTitleWrap>
            <CollectInfoDescription>{'필요한 정보는 총 7가지예요'}</CollectInfoDescription>
          </CollectInfoTopSection>

          <BulletListContainer>
            <BulletListItem>{'브랜드'}</BulletListItem>
            <BulletListItem>{'모델명'}</BulletListItem>
            <BulletListItem>{'마력'}</BulletListItem>
            <BulletListItem>{'연식'}</BulletListItem>
            <BulletListItem>{'사용시간'}</BulletListItem>
            <BulletListItem>{'판매 지역'}</BulletListItem>
            <BulletListItem>{'판매 가격'}</BulletListItem>
          </BulletListContainer>
        </CollectInfoWrap>

        <HR />

        <CollectInfoWrap>
          <CollectInfoTopSection>
            <CollectInfoTitleWrap>
              <CollectInfoTitle>{'트랙터 필수 사진'}</CollectInfoTitle>
              <Chip type="square" color="secondary" theme="light">
                {'필수'}
              </Chip>
            </CollectInfoTitleWrap>
            <CollectInfoDescription>{'필요한 사진은 총 4장이예요'}</CollectInfoDescription>
          </CollectInfoTopSection>

          <BulletListContainer>
            <BulletListItem>{'좌측면 또는 우측면'}</BulletListItem>
            <BulletListItem>{'정면'}</BulletListItem>
            <BulletListItem>{'후면'}</BulletListItem>
            <BulletListItem>{'실내'}</BulletListItem>
          </BulletListContainer>
        </CollectInfoWrap>

        <HR />

        <CollectInfoWrap>
          <CollectInfoTopSection>
            <CollectInfoTitleWrap>
              <CollectInfoTitle>{'트랙터 선택 사진'}</CollectInfoTitle>
              <Chip type="square" color="primary" theme="light">
                {'선택'}
              </Chip>
            </CollectInfoTitleWrap>
            <CollectInfoDescription>{'등록가능한 사진은 최대 6장이예요'}</CollectInfoDescription>
          </CollectInfoTopSection>

          <BulletListContainer>
            <BulletListItem>{'앞 타이어'}</BulletListItem>
            <BulletListItem>{'뒷 타이어'}</BulletListItem>
            <BulletListItem>{'작업기'}</BulletListItem>
            <BulletListItem>{'기타 사진 (최대 3장)'}</BulletListItem>
          </BulletListContainer>
        </CollectInfoWrap>
      </CollectInfoSection>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  padding: 0px var(--radius-large, 16px) 32px var(--radius-large, 16px);
  gap: var(--radius-large, 16px);
`;

const CollectInfoSection = styled.div`
  display: flex;
  padding: 32px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const CollectInfoWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--radius-large, 16px);
  align-self: stretch;

  border-radius: var(--radius-medium, 8px);
`;

const CollectInfoTopSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  gap: var(--radius-small, 4px);
`;

const CollectInfoTitleWrap = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`;

const CollectInfoTitle = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 23.4px */
`;

const CollectInfoDescription = styled.span`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const HR = styled.hr`
  width: 100%;
  height: 0px;

  border: 0.5px solid #e4e4ed;
`;
